<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="2">
        <v-select 
          :items="query_targets" 
          v-model="query_target"
          item-text="text"
          item-value="ref" 
          solo dense></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field 
          label="Busca" 
          v-model="query" 
          @click:append="search()" 
          append-icon="mdi-magnify" 
          v-on:keyup.enter="search()"
          solo dense>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ counter }} registros encontrados
        </v-alert>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Plano</th>
          <th>Instalação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.clientName }}</td>
          <td>{{ item.planName }}</td>
          <td>{{ item.setup | formatDate }}</td>
          <td><v-btn icon @click="details(item)"><v-icon>mdi-magnify</v-icon></v-btn></td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: () => ({
    current: [],
    counter: 0,
    query: "",
    query_target: "name",
    query_targets: [
      {ref: "name", text: "Nome"},
      {ref: "cnpx", text: "CPF/CNPJ"},
      {ref: "telephone", text: "Telefone"},
      {ref: "cellphone", text: "Celular"},
      {ref: "email", text: "E-mail"}
    ],
    dialog_loading: false
  }),
  created: function() {
    this.count();
  },
  methods: {
    count: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/contract/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.counter = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    details: function(item) {
      router.push({ path: `/contract/${item.id}` });
    },
    search: function() {
      var me = this;
      if(me.query==""){
        this.count();
        return;
      }
      if(me.query.length<3){
        alert("A busca precisa ter pelo menos 3 caracteres!");
        return;
      }
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/contract/"+this.query_target+"/"+this.query, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.counter = response.data.length;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar registros!");
        });
    }
  }
};
</script>